export enum COMMUNICATION_WAY {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}
